<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->


<template>
    <v-select
        :value="value"
        :items="projects"
        item-text="name"
        item-value="projectId"
        persistent-hint
        return-object
        single-line
        :placeholder="language.t('RobotPlotter.CreateTask.chooseProject')"
        @input="$emit('input', $event)"
        dense
    >
        <template
            slot="selection"
            slot-scope="data"
        >
            {{ data.item.name }} </template>
        <template
            slot="item"
            slot-scope="data"
        >
            {{ data.item.name }}
            {{ data.item.projection ? "- " + data.item.projection.name : "" }}</template>
    </v-select>
</template>

<script>
export default {
    props: ['value'],
    computed: {
        projects: {
            get() {
                return this.$projects.all
            }
        }
    }
}
</script>
